var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageModal)?_c('div',{attrs:{"id":"lightbox"},on:{"click":function($event){_vm.imageModal=null}}},[_c('vs-icon',{staticClass:"close",attrs:{"icon":"close"}}),_c('img',{attrs:{"src":_vm.imageModal,"alt":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }